import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'icon-plus',
  templateUrl: './icon-plus.component.html',
  styleUrls: ['./icon-plus.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class IconPlusComponent {}
